<p-chart [type]="chartType" [data]="data"></p-chart>
